export type BerThongReceiptImageInput = {
  sheetCode?: string
  sheetTitle?: string
  huayName?: string
  drawDate?: string
  betTypeLabel?: string
  numbers: string[]
  unitPrice: number
  totalAmount: number
  purchaseId?: string
  purchasedAt?: string | Date
  username?: string
}

function formatWhen(value?: string | Date) {
  if (!value) return '—'
  const d = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  return d.toLocaleString('th-TH', { hour12: false })
}

/** วาดใบเสร็จระบบ (PNG data URL) สำหรับเก็บหลักฐานแอดมิน + ลูกค้า */
export function generateBerThongReceiptDataUrl(input: BerThongReceiptImageInput): string {
  const width = 720
  const padding = 36
  const lineH = 28
  const numbers = (input.numbers || []).map(String)
  const numberLines: string[] = []
  let buf = ''
  numbers.forEach((n, i) => {
    const next = buf ? `${buf}, ${n}` : n
    if (next.length > 42) {
      if (buf) numberLines.push(buf)
      buf = n
    } else {
      buf = next
    }
    if (i === numbers.length - 1 && buf) numberLines.push(buf)
  })
  if (numberLines.length === 0) numberLines.push('—')

  const rows = [
    ['รหัสแผ่น', input.sheetCode || '—'],
    ['ชื่อแผ่น', input.sheetTitle || 'เบอร์ทอง'],
    ['หวย', input.huayName || '—'],
    ['งวด', input.drawDate || '—'],
    ['ประเภท', input.betTypeLabel || '—'],
    ['ลูกค้า', input.username || '—'],
    ['เวลาซื้อ', formatWhen(input.purchasedAt)],
    ['ราคา/เบอร์', `${Number(input.unitPrice || 0).toLocaleString()} ฿`],
    ['จำนวนเบอร์', String(numbers.length)],
    ['ยอดรวม', `${Number(input.totalAmount || 0).toLocaleString()} ฿`],
    ['รหัสรายการ', input.purchaseId || '—'],
  ]

  const height = padding * 2 + 70 + rows.length * lineH + 24 + numberLines.length * 26 + 64
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = Math.max(height, 420)
  const ctx = canvas.getContext('2d')
  if (!ctx) return ''

  ctx.fillStyle = '#0f172a'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  const grad = ctx.createLinearGradient(0, 0, canvas.width, 120)
  grad.addColorStop(0, '#92400e')
  grad.addColorStop(1, '#b45309')
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, canvas.width, 88)

  ctx.fillStyle = '#fffbeb'
  ctx.font = 'bold 28px Kanit, Sarabun, sans-serif'
  ctx.fillText('ใบเสร็จเบอร์ทอง', padding, 42)
  ctx.font = '16px Kanit, Sarabun, sans-serif'
  ctx.fillText('หลักฐานการซื้อ (ระบบออกให้อัตโนมัติ)', padding, 70)

  ctx.fillStyle = '#f8fafc'
  ctx.fillRect(padding - 8, 108, canvas.width - padding * 2 + 16, canvas.height - 140)

  let y = 140
  ctx.font = '15px Kanit, Sarabun, sans-serif'
  rows.forEach(([label, value]) => {
    ctx.fillStyle = '#64748b'
    ctx.fillText(label, padding + 8, y)
    ctx.fillStyle = '#0f172a'
    ctx.font = 'bold 15px Kanit, Sarabun, sans-serif'
    const text = String(value)
    const clipped = text.length > 48 ? `${text.slice(0, 47)}…` : text
    ctx.fillText(clipped, padding + 160, y)
    ctx.font = '15px Kanit, Sarabun, sans-serif'
    y += lineH
  })

  y += 8
  ctx.fillStyle = '#92400e'
  ctx.font = 'bold 16px Kanit, Sarabun, sans-serif'
  ctx.fillText('เบอร์ที่ซื้อ', padding + 8, y)
  y += 28
  ctx.fillStyle = '#0f172a'
  ctx.font = 'bold 18px Kanit, Sarabun, sans-serif'
  numberLines.forEach((line) => {
    ctx.fillText(line, padding + 8, y)
    y += 26
  })

  ctx.fillStyle = '#94a3b8'
  ctx.font = '12px Kanit, Sarabun, sans-serif'
  ctx.fillText('เก็บไว้เป็นหลักฐาน — แอดมินและลูกค้าดูได้จากระบบ', padding, canvas.height - 24)

  return canvas.toDataURL('image/png')
}
